import cookies from 'js-cookie';
import store from './store';
import keys from './store/constants/keys';
import { initializeI18next, initializeLocale } from './i18n';
import widgets from './widgets';
import runWidgets from './utils/run-widgets';
import configureYousersJS from './modules/user/helpers/configure-yousersjs';
import configureSubscriptionsManager from './modules/subscriptions/helpers/configure-subscriptions-manager';

const { MadeWithYola, Navbar, LanguageSelector, DifmPromoBanner } = widgets;

const init = () => {
  configureYousersJS();
  configureSubscriptionsManager();

  store.set(keys.YOLA_COOKIE, cookies.get('Yola') || null);

  initializeLocale();
  initializeI18next().then(() => {
    runWidgets([Navbar, MadeWithYola, LanguageSelector, DifmPromoBanner]);
  });
};

export default init;
